import firebase from 'firebase';
import _ from 'lodash';

import View from '../_components/view/view.js';
import adminSectionTpl from './admin-section.tpl.html';
import './admin-section.styles.less';

import UsersView from './users/users.view.js';
import PlayersView from './players/players.view.js';
import GroupsView from './groups/groups.view.js';
import RoundsView from './rounds/rounds.view.js';
import NewsManagerView from './news/news-manager.view.js';

class SectionsBarView extends View {

	constructor (data, options) {
		super(adminSectionTpl, data, options);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			adminSectionsContainer: '.admin-sections-container',
			btnUsers: '.btn-users',
			btnPlayers: '.btn-players',
			btnGroups: '.btn-groups',
			btnRounds: '.btn-rounds',
			btnNews: '.btn-news'
		});
	}

	render(data) {
		super.render(data);

		//Players View is the default view
		this.currentView = this.playersView = new PlayersView();
		this.currentView.show(this.ui.adminSectionsContainer);

	}

	initializeEvents() {
		this.ui.btnUsers.click(() => this.showSection(
			this.usersView, 'usersView', UsersView
		));
		this.ui.btnPlayers.click(() => this.showSection(
			this.playersView, 'playersView', PlayersView
		));
		this.ui.btnGroups.click(() => this.showSection(
			this.groupsView, 'groupsView', GroupsView
		));
		this.ui.btnRounds.click(() => this.showSection(
			this.roundsView, 'roundsView', RoundsView
		));
		this.ui.btnNews.click(() => this.showSection(
			this.newsManagerView, 'newsManagerView', NewsManagerView
		));
	}

	showSection(view, viewPropKey, ViewClass) {
		if (!view) {
			this[viewPropKey] = view = new ViewClass();
		}
		
		this.currentView.detach();
		this.currentView = view;
		this.currentView.show(this.ui.adminSectionsContainer);
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
		
	}

}

export default SectionsBarView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/admin-section.view.js